export default __webpack_public_path__ + "static/media/alert.8ae5ec62.svg";